<template>
  <el-dialog title="编辑订单" class="global-dialog" :visible.sync="showDlg" width="800px" :before-close="handleClose">
    <div class="dlg-content">
      <el-form class="global-form  " v-loading="loading" style="padding:30px 40px 20px 20px" :model="formData"
        :rules="rules" ref="form3" label-width="120px">
        <el-row>
          <el-col :span="12">
            <el-form-item prop="isDepositAmount" label="保证金">
              <el-radio-group v-model="formData.isDepositAmount">
                <el-radio label="1">抵货款</el-radio>
                <el-radio label="2">未抵货款</el-radio>
              </el-radio-group>
            </el-form-item>

          </el-col>
          <el-col :span="12">
            <el-form-item prop="isGoodsAmount" label="是否超额提货">
              <el-radio-group :disabled="!hasCeEdit" v-model="formData.isGoodsAmount">
                <el-radio label="1">是</el-radio>
                <el-radio label="2">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item prop="vehicleKey" label="车/船号">
              <el-input v-model="formData.vehicleKey" placeholder="请输入车/船号" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="vehicleGph" label="挂车号">
              <el-input v-model="formData.vehicleGph" placeholder="请输入挂车号" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="driverName" label="联系人">
              <el-input v-model="formData.driverName" placeholder="请输入联系人" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="driverKey" label="身份证">
              <el-input v-model="formData.driverKey" placeholder="请输入身份证" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="driverMobile" label="联系电话">
              <el-input v-model="formData.driverMobile" placeholder="请输入联系电话" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="vehicleStartAddress" label="提货库点">
              <el-select v-model="formData.vehicleStartAddress" filterable>
                <el-option :value="item.dicCode" :label="item.dicValue" v-for="(item, index) of vehicleStartAddressList"
                  :key="index"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="vehicleEndAddress" label="卸货库点">
              <el-input v-model="formData.vehicleEndAddress" placeholder="请输入卸货库点" clearable></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="submitDlg">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { validPhoneNumber, validIDCard } from '@/utils/validator'
export default {
  props: {
    showDlg: {
      type: Boolean,
      default: false
    },
    pickupId: {
      type: String,
      default: ''
    },
    isDepositAmount: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      vehicleStartAddressList: [],
      formData: {
        pickupId: '',
        isDepositAmount: '',
        isGoodsAmount: '2',
        vehicleKey: '', // 车牌号
        vehicleGph: '', //  挂车号
        driverName: '', //  司机姓名
        driverKey: '', //  司机身份证
        driverMobile: '', //  司机手机号
        vehicleStartAddress: '', //  提货库点
        vehicleEndAddress: '' //  卸货库点
      },
      rules: {
        // vehicleKey: [
        //   {
        //     pattern: validLicensePlate,
        //     message: '请输入正确的车牌号',
        //     trigger: ['blur', 'change']
        //   }
        // ],
        isDepositAmount: [
          {
            required: true,
            message: '请选择保证金抵扣货款',
            trigger: ['blur', 'change']
          }
        ],
        isGoodsAmount: [
          {
            required: true,
            message: '请选择是否超额提货',
            trigger: ['blur', 'change']
          }
        ],
        driverKey: [
          {
            pattern: validIDCard,
            message: '请输入正确的身份证',
            trigger: ['blur', 'change']
          }
        ],
        driverMobile: [
          {
            pattern: validPhoneNumber,
            message: '请输入正确的手机号',
            trigger: ['blur', 'change']
          }
        ]
      },
      loading: false
    }
  },
  created() {
    // this.formData.isDepositAmount = this.isDepositAmount || '2'
    // this.formData.pickupId = this.pickupId || ''
    this.getDetail()
    this.loadDict()
  },
  computed: {
    buttonList() {
      return this.$store.state.buttonList.map(item => item.butCode)
    },
    hasCeEdit() {
      return this.buttonList.includes('ceedit')
    }
  },
  methods: {
    loadDict() {
      this.$axios.get(this.$apis.common.selectDicByList, {
        params: { dicType: 'vehicleStartAddress' }
      }).then(res => {
        this.vehicleStartAddressList = res.vehicleStartAddress
      })
    },
    getDetail() {
      this.loading = true

      this.$axios
        .get(this.$apis.deliveryOrder.selectYxPickupOrderByPickupId, {
          params: { pickupId: this.pickupId }
        })
        .then(res => {
          // res.fileList = res.fileList ? res.fileList : []
          // res.recordList = res.recordList ? res.recordList : []
          // res.lockedList = res.lockedList ? res.lockedList : []
          // this.formData = res
          this.formData.pickupId = res.pickupId
          this.formData.isDepositAmount = res.isDepositAmount || '2'
          this.formData.isGoodsAmount = res.isGoodsAmount || '2'
          this.formData.vehicleKey = res.vehicleKey // 车牌号
          this.formData.vehicleGph = res.vehicleGph //  挂车号
          this.formData.driverName = res.driverName //  司机姓名
          this.formData.driverKey = res.driverKey //  司机身份证
          this.formData.driverMobile = res.driverMobile //  司机手机号
          this.formData.vehicleStartAddress = res.vehicleStartAddress //  提货库点
          this.formData.vehicleEndAddress = res.vehicleEndAddress //  卸货库点
          this.formData.orderType = res.orderType || '2'
        })

        .finally(() => {
          this.loading = false
        })
    },

    handleClose() {
      this.$emit('closeDlg')
    },

    submitDlg() {
      this.$refs.form3
        .validate()
        .then(() => {
          this.loading = true

          const url = this.$apis.deliveryOrder.updateYxPickupOrder

          this.$axios.post(url, this.formData).then(() => {
            this.$emit('saveSuccess')
            this.handleClose()
          })
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style scoped lang="scss">
.images-wrap {
  display: flex;
  flex-wrap: wrap;

  .images-box {
    width: 148px;
    height: 148px;
    border: 1px dotted #ddd;
    border-radius: 10px;
    margin-right: 10px;
    position: relative;
    margin-bottom: 10px;

    .close-icon {
      position: absolute;
      top: 0;
      right: 0;
      transform: translate(50%, -50%);
      z-index: 10;
      font-size: 18px;
      color: red;
      cursor: pointer;
    }
  }
}

.uplaod-wrap {
  display: flex;
  flex-wrap: wrap;
}
</style>
